import {useGetScheduledActivitiesCount} from '../../../core-entity/widgets/activities-widget/hooks/use-get-scheduled-activities-count';
import type {WidgetCounts} from '../../../core-entity/workspace/helpers';

import {useGetTaskDisplayCount} from './graphql/hooks/use-get-task-display-count';

export function getWidgetFallbackLabel(type: string, nameVal?: string | null): string {
    if (nameVal) return nameVal;
    switch (type) {
        case 'COMPANIES_AND_PEOPLE':
            return 'Actions';
        case 'CUSTOM_CUSTOM_FIELDS':
            return 'Custom fields';
        case 'AUTOMATED_EMAILS':
            return 'Automated emails';
        case 'TASKS':
            return 'Tasks';
        case 'ACTIVITIES':
            return 'Activities';
        case 'GOALS':
            return 'Goals';
        case 'TIMELINE':
            return 'Timeline';
        case 'OLD_SALES_PROCESS':
            return 'Sales process';
        default:
            return 'Widget';
    }
}

export function useGetWidgetCounts(leadId: string): WidgetCounts {
    const {displayCount: tasksDisplayCount} = useGetTaskDisplayCount(leadId);
    const scheduledActivitiesCount = useGetScheduledActivitiesCount(leadId);

    return {
        tasks: tasksDisplayCount ? `${tasksDisplayCount}` : undefined,
        activities: scheduledActivitiesCount,
    };
}
